export const ONE_SIZE_ID = 'ONE SIZE';

export const LETTER_SIZE_TABLE = {
  [ONE_SIZE_ID]: 100,
  XXXS: 200,
  XXS: 300,
  'XXS A-C': 301,
  'XXS D-DD': 302,
  XS: 400,
  'XS A-C': 401,
  'XS D-DD': 402,
  S: 500,
  'S A-C': 501,
  'S D-DD': 502,
  M: 600,
  'M A-C': 601,
  'M D-DD': 602,
  L: 700,
  'L A-C': 701,
  'L D-DD': 702,
  XL: 800,
  'XL A-C': 801,
  'XL D-DD': 802,
  XXL: 900,
  XXXL: 1000,
} as Record<string, number>;
